import { useCallback, useState } from 'react';
import { OptionKey, usePaginationParams } from '@common-fe/common-fe';

import { ALL_OPTION, SORT_OPTIONS } from '@/common/constants';

const useSearchParams = () => {
  const [sortParams, setSortParams] = useState<OptionKey>(SORT_OPTIONS[1].key);
  const [years, setYears] = useState<OptionKey[]>([ALL_OPTION.value]);
  const { page, setPage, setPerPage, perPage, searchString, setSearchString, currentSearch } =
    usePaginationParams(10);
  const handleSetYears = useCallback(
    (values: OptionKey[]) => {
      setYears(values);
      setPage(1);
    },
    [setPage]
  );
  return {
    page,
    setPage,
    setPerPage,
    perPage,
    searchString,
    setSearchString,
    currentSearch,
    sortParams,
    setSortParams,
    years,
    setYears: handleSetYears,
  };
};

export default useSearchParams;
